import { render, staticRenderFns } from "./NestedTable.vue?vue&type=template&id=863b2db2&scoped=true&"
import script from "./NestedTable.vue?vue&type=script&lang=js&"
export * from "./NestedTable.vue?vue&type=script&lang=js&"
import style0 from "./NestedTable.vue?vue&type=style&index=0&id=863b2db2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863b2db2",
  null
  
)

export default component.exports